import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { CreditCard, Plus } from "lucide-react";

export default function PaymentMethodPicker({ cards, selectedCardId, onSelect, onAddCardClick }) {
    if (!cards.length) {
        return (
            <div className="text-sm text-muted-foreground">
                <p>No saved cards yet.</p>
                <Button variant="outline" className="w-full mt-3" onClick={onAddCardClick} data-testid="add-card-button">
                    <Plus className="h-4 w-4 mr-1" /> Add payment method
                </Button>
            </div>
        );
    }
    return (
        <>
            <RadioGroup value={selectedCardId} onValueChange={onSelect} className="space-y-2">
                {cards.map((card) => (
                    <Label
                        key={card.id}
                        className={`flex items-center gap-3 rounded-lg border border-border p-3 cursor-pointer ${
                            selectedCardId === card.id
                                ? "bg-secondary border-[hsl(var(--brand-terracotta))]"
                                : ""
                        }`}
                        data-testid="payment-card-option"
                    >
                        <RadioGroupItem value={card.id} className="sr-only" />
                        <CreditCard className="h-5 w-5 text-muted-foreground" />
                        <div>
                            <div className="font-medium">
                                {card.brand} •••• {card.last4}
                            </div>
                            <div className="text-xs text-muted-foreground">
                                {card.holder_name} · exp {card.exp_month}/{card.exp_year}
                            </div>
                        </div>
                        {card.is_default && (
                            <span className="ml-auto text-[10px] uppercase tracking-wider text-muted-foreground">Default</span>
                        )}
                    </Label>
                ))}
            </RadioGroup>
            <Button variant="outline" className="w-full mt-3" onClick={onAddCardClick} data-testid="add-card-button">
                <Plus className="h-4 w-4 mr-1" /> Add payment method
            </Button>
        </>
    );
}
